import { mount } from 'svelte';
import './app.css';
import App from './App.svelte';
import { app } from './lib/state.svelte';

const target = document.getElementById('app');
if (!target) throw new Error('#app is missing from index.html');

mount(App, { target });

// The service worker is what makes this installable and openable with no
// signal. Registered after mount so it never delays first paint.
if ('serviceWorker' in navigator && import.meta.env.PROD) {
  // Whether this page was already under a service worker when it loaded. On a
  // first-ever visit the worker activates and claims the page, which fires
  // controllerchange - and reloading there would bounce the app on its first
  // open for no reason.
  const hadController = Boolean(navigator.serviceWorker.controller);
  let reloading = false;

  // A new worker taking over is the only reliable signal that the update has
  // actually landed. Reloading before that just re-renders the old build.
  navigator.serviceWorker.addEventListener('controllerchange', () => {
    if (!hadController || reloading) return;
    reloading = true;
    location.reload();
  });

  window.addEventListener('load', () => {
    void navigator.serviceWorker.register('/sw.js').then((reg) => {
      // Already waiting from a previous visit.
      if (reg.waiting) app.offerUpdate(reg.waiting);

      reg.addEventListener('updatefound', () => {
        const installing = reg.installing;
        if (!installing) return;
        installing.addEventListener('statechange', () => {
          // "installed" with a controller present means a newer build is ready
          // but cannot take over yet. Without a controller it is the first
          // install, which needs no prompt.
          if (installing.state === 'installed' && navigator.serviceWorker.controller) {
            app.offerUpdate(installing);
          }
        });
      });
    });
  });
}
